import { useAffiliateAuth } from '@/features/referrals/api/affiliates/use-affiliate-auth';
import CenteredCard from '@/features/referrals/components/affiliates/centered-card';
import { EventType } from '@/types';
import { sendEvent } from '@/utils/analytics';
import { handleUserForStore } from '@/utils/handle-store-data';
import { useLogin } from '@privy-io/react-auth';
import { ArrowRight } from 'lucide-react';
import { Outlet } from 'react-router-dom';
import { Button } from '../ui';

export default function AffiliatesLayout() {
  const { authenticated, hasPrimaryAuth } = useAffiliateAuth();

  if (!authenticated) {
    return (
      <CenteredCard
        title="Access Affiliates"
        description="Sign in to apply for the Vest affiliate program or manage your links, commissions, and payouts."
        footer={<SignInButton />}
      />
    );
  }

  if (!hasPrimaryAuth) {
    return (
      <CenteredCard
        title="Complete Registration"
        description="Affiliate tools use your primary Vest account. Complete the registration prompt from the wallet menu, then return here."
      />
    );
  }

  return <Outlet />;
}
function SignInButton() {
  const { login } = useLogin({
    onComplete: ({ user }) => handleUserForStore(user),
  });

  const onSignIn = () => {
    sendEvent(EventType.AUTH_FLOW_STARTED);
    login();
  };

  return (
    <Button className="w-full" size="xl" type="button" onClick={onSignIn}>
      Sign in to continue
      <ArrowRight size={16} />
    </Button>
  );
}
